import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { CurrentAccountState, HomeLocationState } from 'src/states';
import { LocationAccountType } from 'src/app/enums/location-account-type.enum';
import { catchError, combineLatest, filter, map, of, switchMap, timeout } from 'rxjs';
import { Logout } from 'src/modules/security/actions/auth-actions';
import { NavigateToPscSearch } from '../states/navigations.actions';

export const currentAccountGuard: CanActivateFn = () => {
  const store = inject(Store);
  const initialized$ = store.select(CurrentAccountState.initialized);

  return initialized$.pipe(
    timeout(30000),
    filter(initialized => initialized),
    switchMap(() => combineLatest([store.select(CurrentAccountState.userLocation), store.select(HomeLocationState.userLocation)])),
    map(([userLocation, homeUserLocation]) => {
      if (userLocation) {
        return true;
      }

      if (homeUserLocation?.accountType === LocationAccountType.PSC) {
        store.dispatch(new NavigateToPscSearch());
      }

      return false;
    }),
    catchError(() => {
      console.error('Current account guard error: dispatching logout');
      store.dispatch(new Logout());
      return of(false);
    })
  );
};
